import { HTTPError } from 'ky';

// TODO: documentazione
class KyHttpError {
  isKyHttpError(err: unknown): err is HTTPError {
    return err instanceof HTTPError;
  }

  async parse(error: HTTPError) {
    const { status } = error.response;
    const data = await error.response.json();

    const msg = data.error.message || data.message;

    switch (status) {
      case 500:
        return 'Server non disponibile, riprovare più tardi';
      case 400:
        return `Richiesta malformata <br> ${msg}`;
      case 404:
        return msg;
      case 403:
        return 'Permessi insufficienti';
      case 413:
        return `Il file caricato è troppo grande <br> ${msg}`;
      default:
        return `${msg}`;
    }
  }
}

export const kyHttpError = new KyHttpError();
